import { useTranslation } from "../i18n";
import ManifestsAdmin from "../components/ManifestsAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

const AdminManifests = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="manifest_settings"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "manifest_settings" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("manifest_settings_hint")}</p>
                <ManifestsAdmin />
            </div>
        </div>
    );
};

export default AdminManifests;
